export function parseThreshold(value) {
  const text = String(value ?? '').trim()
  if (!/^\d+$/.test(text)) return null
  const number = Number(text)
  return Number.isSafeInteger(number) && number <= 2147483647 ? number : null
}

export function appendProductThreshold(data, value, original) {
  const threshold = parseThreshold(value)
  if (threshold === null) throw new Error('La soglia deve essere un intero non negativo.')
  if (original === undefined || threshold !== Number(original)) {
    data.append('soglia_minima_giacenza', threshold)
  }
}

export function changedInventoryFields(form, original) {
  const threshold = parseThreshold(form.soglia_minima)
  if (threshold === null) throw new Error('La soglia deve essere un intero non negativo.')
  const quantity = Number(form.quantita_disponibile)
  if (String(form.quantita_disponibile).trim() === '' || !Number.isSafeInteger(quantity)) {
    throw new Error('La quantità deve essere un numero intero.')
  }
  const values = {
    quantita_disponibile: quantity,
    soglia_minima: threshold,
    ubicazione: form.ubicazione.trim(),
  }
  return Object.fromEntries(Object.entries(values).filter(([key, value]) => value !== original[key]))
}

export function invalidateProductStock(queryClient) {
  return Promise.all([
    'prodotti', 'prodotto', 'giacenze-prodotti', 'giacenza-prodotto',
    'giacenze-prodotti-sottoscorta', 'dashboard-operativa',
  ].map((key) => queryClient.invalidateQueries({ queryKey: [key], refetchType: 'all' })))
}
